{
  "table": {
    "object": "Objet",
    "type": "Type",
    "message": "Message",
    "state": "État",
    "actions": "Actions",
    "createdAt": "Créé",
    "client": "Client",
    "userFirstName": "Prénom de l'utilisateur",
    "userLastName": "Nom de famille de l'utilisateur",
    "date": "Date",
    "amount": "Montant",
    "accountType": "Type de compte",
    "ticker": "Symbole",
    "currency": "Devise",
    "price": "Prix",
    "quantity": "Quantité",
    "organization": "Organisation",
    "processDate": "Date de traitement",
    "objectType": "Type d'objet",
    "effectiveDate": "Date d'entrée en vigueur",
    "settleDate": "Date de règlement",
    "custodianAccountNumber": "Numéro de compte du bénéficiaire",
    "clientName": "Nom du client",
    "transaction": "Transaction",
    "subTransaction": "Sous-transaction",
    "cusip": "CUSIP",
    "transactionDesc": "Description de la transaction",
    "transactionType": "Type de transaction",
    "commission": "Commission",
    "accruedInterest": "Intérêt accru",
    "securityType": "Type de valeur mobilière",
    "custodian": "Dépositaire(trice)",
    "account": "Compte",
    "flags": "Indicateurs",
    "systemUpdated": "Système mis à jour",
    "externalUpdated": "Mise à jour externe"
  },
  "state": "État",
  "exportProgressTitleFlags": "Exporter les indicateurs",
  "exportProgressTitleActivities": "Exporter les activités",
  "transactionType": "Type de transaction",
  "symbol": "Symbole",
  "custodianAccountNumber": "Numéro de compte du bénéficiaire",
  "type": "Type",
  "any": "Tous",
  "perPage": "Articles par page",
  "goTo": "Aller à",
  "tabs": {
    "flags": "Indicateurs",
    "activities": "Activités",
    "jobs": "Tâches"
  },
  "flagState": {
    "FLAGGED": "Signalé",
    "FIXED": "Terminé",
    "ALL_FIXED": "Marquer la sélection comme terminée",
    "ALL_RECONCILE": "Rapprocher tout",
    "ALL_FORCE_RECONCILE": "Forcer le rapprochement de tous",
    "TRIVIAL": "Trivial"
  },
  "activityState": {
    "CREATED": "Créé",
    "RECONCILED": "Rapproché",
    "RECONCILE": "Rapprocher",
    "FORCE_RECONCILE": "Forcer le rapprochement de tous"
  },
  "jobEventType": {
    "RECONCILIATION": "RAPPROCHEMENT"
  },
  "jobState": {
    "ANY": "TOUS",
    "INITIATED": "INITIÉ",
    "COMPLETED": "TERMINÉ",
    "FAILED": "ÉCHOUÉ"
  },
  "eventTable": {
    "eventType": "Type d'événement",
    "jobName": "Nom de la tâche",
    "ranAt": "Exécuté à",
    "updatedAt": "Mis à jour",
    "state": "État",
    "organization": "Organisation",
    "action": "Action"
  },
  "runReconciliation": {
    "title": "Exécuter le rapprochement",
    "reconcileActivities": "Activités de rapprochement",
    "updateCashAndHoldings": "Mettre à jour les liquidités et les actifs",
    "reconCashAndHoldings": "Rapprocher les liquidités et les actifs",
    "publishSnapshots": "Publier les instantanés",
    "runReconcileToastMessage": "Rapprochement demandé"
  },
  "accountSnapshot": {
    "security": "Sécurité",
    "systemQuantity": "Quantité",
    "externalQuantity": "Quantité externe",
    "diffQuantity": "Quantité différente",
    "systemPrice": "Prix",
    "externalPrice": "Prix externe",
    "diffPrice": "Prix différent",
    "systemValue": "Valeur système",
    "externalValue": "Valeur externe",
    "diffValue": "Valeur différente",
    "systemBookValue": "Valeur comptable",
    "externalBookValue": "Valeur comptable externe",
    "diffBookValue": "Valeur comptable différente",
    "ledger": "Grand livre",
    "transfers": "Transferts",
    "tradeOrders": "Ordres de transaction",
    "custodianActivities": "Activités externes",
    "total": "Total"
  },
  "jobDetails": {
    "title": "Détails supplémentaires pour {{jobName}} exécutée le {{ranAt}}"
  },
  "reconFlags": {
    "title": "Rapprochement",
    "summaryTitle": "Tableau de bord sommaire",
    "spotlight": {
      "negativeCash": {
        "title": "Compte de trésorerie négatif"
      },
      "negativeHolding": {
        "title": "Détention négative"
      },
      "holdingsMismatch": {
        "title": "Déséquilibre des détentions"
      },
      "moneyAvailableMismatch": {
        "title": "Déséquilibre des fonds disponibles"
      }
    },
    "totalFlags": "Total des indicateurs",
    "totalFlagsHint": "SIGNALÉS dans l'organisation",
    "unresolvedThreePlus": "Non résolus depuis 3 jours et plus",
    "unresolvedThreePlusHint": "SIGNALÉS, créés il y a plus de 3 jours",
    "severity": {
      "all": "Tous",
      "critical": "Critique",
      "high": "Élevée",
      "medium": "Moyenne",
      "low": "Faible"
    },
    "severityLabel": {
      "CRITICAL": "Critique",
      "HIGH": "Élevée",
      "MEDIUM": "Moyenne",
      "LOW": "Faible",
      "UNKNOWN": "Inconnue"
    },
    "filters": {
      "flagType": "Type d'indicateur",
      "category": "Catégorie",
      "aging": "Ancienneté",
      "any": "Tous",
      "agingOneDay": "1 jour et plus",
      "agingThreeDays": "3 jours et plus",
      "agingSevenDays": "7 jours et plus",
      "clearFilters": "Effacer les filtres",
      "priority": "Priorité"
    },
    "categories": {
      "snapshot": "Instantané",
      "warning": "Avertissement",
      "cashHoldings": "Compte de trésorerie et détentions",
      "activity": "Activité",
      "transfer": "Transfert",
      "account": "Compte",
      "product": "Produit"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Compte de trésorerie négatif",
      "NEGATIVE_HOLDING": "Détention négative",
      "DIFFERENT_HOLDINGS_V2": "Déséquilibre des détentions",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Déséquilibre des fonds disponibles"
    },
    "searchPlaceholder": "Rechercher par nom de client",
    "searchHelp": "Affiche les indicateurs pour un maximum de {{max}} comptes les plus pertinents. Affinez votre recherche si les résultats semblent incomplets.",
    "searchHelpAria": "À propos des limites de recherche de compte",
    "selection": {
      "count": "{{count}} exceptions sélectionnées",
      "selectAllOnPage": "Sélectionner tout sur la page",
      "clear": "Effacer la sélection",
      "dismiss": "Ignorer {{count}}",
      "dismissConfirmTitle": "Ignorer {{count}} indicateurs sélectionnés?",
      "dismissConfirmBody": "Ceci marquera les indicateurs sélectionnés comme résolus. Cette action ne peut pas être annulée à partir de cet écran.",
      "dismissConfirmAction": "Ignorer {{count}}",
      "resolve": "Résoudre",
      "resolveConfirmTitle": "Résoudre les indicateurs sélectionnés?",
      "resolveConfirmBody": "Ceci marquera le(s) indicateur(s) sélectionné(s) comme Résolu(s) et le(s) retirera de la liste Active. Cette action ne peut pas être annulée à partir de cet écran.",
      "resolveConfirmAction": "Résoudre"
    },
    "table": {
      "account": "Compte",
      "firstSeen": "Première apparition"
    },
    "agingDays_one": "{{count}} jour",
    "agingDays_other": "{{count}} jours",
    "drawer": {
      "close": "Fermer",
      "title": "Détail de l'indicateur",
      "fallbackTitle": "Détails de l'indicateur",
      "detailsHeading": "Détails",
      "summary": {
        "type": "Type :",
        "account": "Compte :",
        "date": "Date :",
        "firstSeen": "Première apparition :"
      },
      "followUpTask": "Créer une tâche de suivi",
      "resolve": "Résoudre",
      "resolveSuccess": "Indicateur résolu",
      "resolveError": "Impossible de résoudre cet indicateur",
      "tabs": {
        "overview": "Aperçu",
        "rawJson": "JSON brut",
        "notes": "Notes"
      },
      "sections": {
        "issueSummary": "Résumé du problème",
        "flagSummary": "Résumé de l'indicateur",
        "account": "Compte",
        "activity": "Activité et transfert dépositaire",
        "systemIdentifiers": "Identifiants système",
        "additional": "Détails supplémentaires"
      },
      "fields": {
        "flagType": "Type d'indicateur",
        "objectType": "Type d'objet",
        "priority": "Priorité",
        "created": "Créé",
        "state": "État",
        "custodianAcctShort": "Nº de compte dépositaire",
        "accountStatus": "Statut du compte",
        "transactionId": "ID de transaction",
        "subTransactionId": "ID de sous-transaction",
        "financialProductId": "ID de produit financier",
        "activityType": "Type",
        "activityStatus": "Statut",
        "firstSeen": "Première apparition"
      },
      "internalNotesHeading": "Notes internes",
      "notesLabel": "Notes",
      "notesPlaceholder": "Ajoutez des notes concernant votre enquête…",
      "notesSaved": "Notes enregistrées",
      "notesSaveError": "Impossible d'enregistrer les notes",
      "discardDraftConfirmTitle": "Jeter la note non enregistrée?",
      "discardDraftConfirmBody": "Vous avez une note qui n'a pas été enregistrée. Fermer sans enregistrer?",
      "discardDraftConfirmAction": "Jeter et fermer",
      "dismissSuccess": "Indicateur ignoré",
      "dismissError": "Impossible d'ignorer cet indicateur",
      "notesHistoryEmptyTitle": "Aucune note pour l'instant",
      "notesHistoryEmptyReadOnlyTitle": "Aucune note pour cet indicateur",
      "notesHistoryEmptyDescription": "Ajoutez une note pour saisir le contexte important concernant cet indicateur.",
      "addNote": "Ajouter une note"
    },
    "bulkDismissError": "Impossible d'ignorer les indicateurs sélectionnés",
    "bulkDismissSuccess": "{{count}} indicateurs ignorés",
    "bulkDismissPartial": "{{failed}} sur {{total}} indicateurs n'ont pas pu être ignorés",
    "bulkDismissNoFlaggedSelected": "Aucun des indicateurs sélectionnés ne peut être ignoré. Seuls les indicateurs signalés peuvent être résolus à partir de cette vue.",
    "emptyTable": "Aucun indicateur ne correspond aux filtres actuels.",
    "pagination": {
      "summary": "Affichage de {{start}}–{{end}} sur {{total}} indicateurs"
    },
    "flagState": {
      "FLAGGED": "Signalé",
      "FIXED": "Résolu",
      "TRIVIAL": "Ignoré"
    },
    "emptyTableHint": "Essayez d'ajuster vos filtres ou votre recherche.",
    "emptyTableNoResults": "Aucun indicateur trouvé.",
    "emptyTableNoData": "Aucune donnée disponible.",
    "agingHelp": "Jours depuis que ce problème a été <bold>observé pour la première fois</bold> (Première apparition). L'indicateur peut être actualisé quotidiennement lorsque le rapprochement réémet le même problème; cela ne <bold>réinitialise pas</bold> l'ancienneté. Résolvez ou ignorez lorsque le problème est corrigé.",
    "agingHelpAria": "À propos de la colonne d'ancienneté",
    "searchError": "La recherche de client a échoué. Veuillez réessayer.",
    "bulkResolveError": "Impossible de résoudre les indicateurs sélectionnés",
    "bulkResolveSuccess": "{{count}} indicateurs résolus",
    "bulkResolvePartial": "{{failed}} sur {{total}} indicateurs n'ont pas pu être résolus",
    "bulkResolveNoFlaggedSelected": "Aucun des indicateurs sélectionnés ne peut être résolu. Seuls les indicateurs actifs peuvent être résolus à partir de cette vue."
  },
  "flagGlossary": {
    "title": "Glossaire des indicateurs",
    "openGlossary": "Glossaire",
    "backToFlags": "Retour aux indicateurs",
    "searchPlaceholder": "Rechercher des indicateurs",
    "loadError": "Impossible de charger le glossaire des indicateurs. Veuillez réessayer.",
    "emptyTable": "Aucun indicateur ne correspond aux filtres actuels.",
    "emptyTableHint": "Essayez d'ajuster vos filtres ou votre recherche.",
    "emptyTableNoResults": "Aucun indicateur trouvé.",
    "emptyTableNoData": "Aucune donnée de glossaire d'indicateurs disponible.",
    "emptyTableError": "Impossible de charger les indicateurs.",
    "emptyTableErrorHint": "Une erreur s'est produite. Veuillez réessayer.",
    "filters": {
      "category": "Catégorie",
      "clearFilters": "Effacer les filtres"
    },
    "kpi": {
      "total": "Total des indicateurs disponibles",
      "totalHint": "Tous les types d'indicateurs dans le glossaire",
      "thresholded": "Indicateurs à seuil",
      "thresholdedHint": "Indicateurs qui prennent en charge les seuils de montant ou de pourcentage",
      "turnedOff": "Désactivés",
      "turnedOffHint": "Types d'indicateurs désactivés pour cette organisation"
    },
    "table": {
      "flagName": "Nom de l'indicateur",
      "description": "Description",
      "exampleTrigger": "Exemple de déclencheur",
      "category": "Catégorie",
      "actualPriority": "Priorité actuelle",
      "actualThreshold": "Seuil actuel",
      "defaultPriority": "Priorité par défaut",
      "defaultThreshold": "Seuil par défaut"
    },
    "pagination": {
      "summary": "Affichage de {{start}}–{{end}} sur {{total}} types d'indicateurs"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "Une activité de virement dans les données du dépositaire a une quantité, un prix et un symbole valides, mais le montant de la valeur comptable n'a pas de sens pour le type de transaction (un virement entrant devrait avoir une valeur comptable positive; un virement sortant devrait en avoir une négative).",
        "exampleTrigger": "Un virement entrant pour ABC a une quantité de 10 et un prix, mais la valeur comptable est 0, nulle ou manquante dans les données du dépositaire."
      },
      "FEE_NOT_FOUND": {
        "description": "Une activité de frais apparaît dans le flux du dépositaire, mais aucun transfert de retrait de frais correspondant n'a été trouvé sur la plateforme.",
        "exampleTrigger": "Des frais de gestion de 25 $ apparaissent dans les données du dépositaire, mais aucun transfert de frais correspondant n'existe sur la plateforme pour les rapprocher."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "L'activité de frais du dépositaire ne correspond pas à l'activité de frais de la plateforme.",
        "exampleTrigger": "Les frais du dépositaire sont de 125,00 $ et les retraits de frais de la plateforme totalisent 100,00 $."
      },
      "TRADE_NOT_FOUND": {
        "description": "Les données du dépositaire contiennent un enregistrement de transaction, mais la plateforme n'a pas d'entrée de transaction correspondante.",
        "exampleTrigger": "L'activité du dépositaire montre un ACHAT de XYZ sur le compte 123, mais la plateforme n'a pas de transaction correspondante pour le rapprocher."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "Une activité ou un enregistrement dans les données du dépositaire fait référence à un numéro de compte qui n'existe pas sur la plateforme où il est censé être trouvé.",
        "exampleTrigger": "Le dépositaire envoie des données de transaction pour le compte 12345678, le compte 12345678 n'existe pas sur la plateforme."
      },
      "TRANSFER_NOT_FOUND": {
        "description": "Une activité liée à un transfert apparaît dans les données du dépositaire (ou un règlement entrant n'a aucun candidat en cours), mais aucun transfert correspondant n'a été trouvé sur la plateforme.",
        "exampleTrigger": "Le dépositaire enregistre un règlement entrant de 10 000 $ et le compte/sous-compte sur la plateforme n'a aucune transaction de transfert externe DEMANDÉE/EN COURS."
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "Un code ou type d'activité signalé par le dépositaire ou la plateforme ne correspond à aucun type d'activité reconnu dans la configuration de mappage.",
        "exampleTrigger": "Les données du dépositaire incluent un code d'activité sans mappage correspondant à un type d'activité connu sur la plateforme."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "Une activité ou une détention fait référence à un produit financier (titre, fonds, etc.) qui ne figure pas dans le catalogue de produits de la plateforme.",
        "exampleTrigger": "Une transaction fait référence au CUSIP du titre 123456789, mais aucun enregistrement de produit financier correspondant n'existe dans le catalogue de la plateforme."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "Un type d'activité qui n'est attendu que sur les comptes d'entreprise a été enregistré sur un compte non-entreprise à la place.",
        "exampleTrigger": "Une activité d'entreprise est enregistrée sur un compte imposable individuel au lieu d'un compte d'entreprise."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "Plus d'un transfert du dépositaire correspond aux détails d'un seul transfert entrant attendu, de sorte que la plateforme ne peut pas déterminer automatiquement lequel s'applique.",
        "exampleTrigger": "Trois transferts distincts du dépositaire correspondent à la même référence de dépôt et au même montant, de sorte que la plateforme ne peut pas déterminer automatiquement lequel s'applique."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "Une activité fait référence à une devise qui n'est pas activée ou prise en charge pour le compte chez le dépositaire.",
        "exampleTrigger": "Une transaction pour le compte 12345678 est libellée en euros, mais cette devise n'a pas été activée pour la connexion du compte avec le dépositaire."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "Une activité NSF est ignorée car elle correspond à un modèle de réenregistrement du dépositaire : une annulation et un dépôt jumelés du même montant sont enregistrés sur le compte le même jour (souvent utilisé lorsque le dépositaire corrige les codes de contributeur).",
        "exampleTrigger": "Un NSF de -500 $ et un dépôt de +500 $ sont enregistrés sur le même compte le même jour, de sorte que le NSF est ignoré et cet indicateur est levé à la place."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "Une activité de retrait du RAP apparaît dans les données du dépositaire, mais aucun retrait correspondant du Régime d'accession à la propriété n'a été trouvé sur la plateforme pour ce compte.",
        "exampleTrigger": "Les données du dépositaire montrent un retrait du RAP de 35 000 $ sur un compte REER, mais la plateforme n'a aucun retrait correspondant du Régime d'accession à la propriété pour le rapprocher."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "Une activité NSF fait référence à une transaction antérieure qui n'a aucune activité de TEF ou de retrait interne correspondante dans les données du dépositaire pour ce compte et cette devise.",
        "exampleTrigger": "Un NSF de -1 200 $ est reçu, mais aucune activité de TEF ou de retrait interne correspondante n'existe pour ce compte et cette devise."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "Le montant d'un règlement entrant du dépositaire diffère de plus de 10 % de la tolérance fixe de chaque candidat de transfert externe en cours sur le sous-compte. Dans cette tolérance, la plateforme rapproche automatiquement le montant du dépositaire sans lever d'indicateur; en dehors de celle-ci, le rapprochement automatique est bloqué.",
        "exampleTrigger": "Un règlement de 10 000 $ est reçu, mais le seul candidat en cours est de 8 500 $ — un écart de 15 %, en dehors de la tolérance fixe de 10 % — de sorte que la plateforme ne peut pas le rapprocher automatiquement et le signale pour un rapprochement manuel."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "Un enregistrement de transfert du fichier d'importation du dépositaire a été marqué comme échoué et n'a pas été importé avec succès sur la plateforme.",
        "exampleTrigger": "Un enregistrement de transfert dans le fichier d'importation du dépositaire est marqué comme échoué, il n'est donc pas importé sur la plateforme."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "Un transfert initié par l'utilisateur est resté en statut Traitement plus longtemps que l'accord de niveau de service (SLA) de 2 jours ouvrables.",
        "exampleTrigger": "Un retrait est passé au statut Traitement le lundi et y est toujours le mercredi, dépassant le SLA de 2 jours ouvrables."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "Un retrait initié par l'utilisateur est resté en statut Initié pendant 3 jours ouvrables sans progresser.",
        "exampleTrigger": "Un retrait est entré en statut Initié il y a 3 jours ouvrables et y est toujours sans progresser."
      },
      "TRANSFER_STUCK_READY": {
        "description": "Un transfert initié par l'utilisateur est resté en statut Prêt plus longtemps que l'accord de niveau de service (SLA) de 3 jours ouvrables, ou la soumission du dépositaire a échoué d'une manière qui lève ce même indicateur.",
        "exampleTrigger": "Un dépôt est resté en statut Prêt pendant plus de 3 jours ouvrables sans progresser."
      },
      "FAILED_ACCOUNT": {
        "description": "La configuration ou le provisionnement du compte a échoué à mi-chemin du processus, il nécessite donc un suivi opérationnel pour être résolu.",
        "exampleTrigger": "La création du compte est terminée sur la plateforme, mais l'étape d'intégration du dépositaire revient avec un statut d'échec."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "L'ouverture de compte du dépositaire (ou, dans certains cas, la soumission de transfert) revient avec une liste de tâches en attente au lieu de confirmer que le compte a été ouvert.",
        "exampleTrigger": "L'ouverture de compte du dépositaire renvoie une liste de tâches en attente au lieu d'un statut terminé, donc l'indicateur est levé."
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "La soumission de la demande d'ouverture de compte du dépositaire a échoué (exception / ouverture infructueuse), de sorte qu'aucun compte dépositaire confirmé n'a été établi.",
        "exampleTrigger": "La demande d'ouverture de compte du dépositaire échoue avec un délai d'attente de connexion, de sorte qu'aucun compte confirmé n'a été établi et l'indicateur est levé."
      },
      "ACCOUNT_CLOSED": {
        "description": "Les données du dépositaire indiquent que le compte en question est FERMÉ, alors que la plateforme le montre comme ACTIF.",
        "exampleTrigger": "Le compte 12345678 est marqué comme FERMÉ selon les données du dépositaire, la plateforme montre toujours le compte 12345678 comme ACTIF."
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "La valeur marchande d'un compte sur la plateforme a chuté de plus que le seuil configuré (15 % par défaut) par rapport à l'instantané de rapprochement de la veille; les augmentations ne déclenchent pas cet indicateur. Les organisations peuvent définir leur propre seuil (5 % minimum) ou désactiver entièrement l'indicateur pour une connexion dépositaire.",
        "exampleTrigger": "La valeur marchande de la plateforme était de 100 000 $ la veille et de 80 000 $ aujourd'hui — une baisse de 20 % — ce qui dépasse le seuil de l'organisation (15 % par défaut), donc l'indicateur est levé."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "Aucun relevé de compte n'a été trouvé pour le mois précédent, même si le compte affiche toujours une valeur marchande sur la plateforme.",
        "exampleTrigger": "Le compte 98765432 a une valeur marchande de 12 500 $ mais aucun relevé pour juin 2026."
      },
      "CASH_NOT_FOUND": {
        "description": "Divergence entre les données du dépositaire et les données de la plateforme concernant le compte de trésorerie.",
        "exampleTrigger": "Le dépositaire signale un solde de compte de trésorerie pour le compte 12345678, mais la plateforme n'a pas d'enregistrement de compte de trésorerie pour ce compte."
      },
      "HOLDING_NOT_FOUND": {
        "description": "Le dépositaire signale une détention pour un compte qui n'a aucune position correspondante dans les registres de la plateforme.",
        "exampleTrigger": "Le dépositaire signale 200 actions du symbole XYZ pour un compte, mais la plateforme n'affiche aucune position pour ce symbole."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "Une détention existe dans les registres de la plateforme pour un compte, mais les détentions du dépositaire n'incluent pas de position correspondante.",
        "exampleTrigger": "La plateforme affiche 100 actions du symbole ABC pour un compte, mais les détentions du dépositaire ne répertorient pas ce symbole."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "Après le rapprochement du compte de trésorerie, les fonds disponibles dans les données du dépositaire et sur la plateforme ne correspondent pas.",
        "exampleTrigger": "Les données du dépositaire indiquent des fonds disponibles de 100,00 $ et la plateforme affiche 95,00 $."
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "Lors du rapprochement des détentions entre le dépositaire et la plateforme, la quantité diffère pour un actif donné.",
        "exampleTrigger": "Les données du dépositaire indiquent 100 actions de XYZ, tandis que la plateforme en affiche 90."
      },
      "NEGATIVE_CASH": {
        "description": "Le solde du compte de trésorerie d'un compte sur la plateforme est tombé en dessous de zéro, basé sur les propres registres de la plateforme plutôt que sur une comparaison avec les données du dépositaire.",
        "exampleTrigger": "Le solde du compte de trésorerie d'un compte sur la plateforme devient négatif après le règlement d'une transaction, basé uniquement sur les propres registres de la plateforme."
      },
      "NEGATIVE_HOLDING": {
        "description": "La quantité d'actions ou d'unités d'une position de valeur mobilière sur la plateforme est enregistrée comme un nombre négatif, basé sur les propres registres de détentions de la plateforme plutôt que sur une comparaison avec les données du dépositaire.",
        "exampleTrigger": "La quantité d'une détention pour un symbole sur la plateforme est enregistrée comme étant inférieure à zéro, basée uniquement sur les propres registres de la plateforme."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Identique à « Déséquilibre des fonds disponibles V2 », mais la comparaison utilise les fonds disponibles ajustés pour les transactions en attente.",
        "exampleTrigger": "Après ajustement pour les transactions en attente, la plateforme affiche 5 000 $ disponibles, mais l'instantané du dépositaire implique 5 200 $."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Identique à « Déséquilibre des détentions V2 », mais la quantité de la plateforme est ajustée pour les transactions en attente avant d'être comparée à celle du dépositaire.",
        "exampleTrigger": "Après les ventes en attente, la plateforme projette 50 actions du symbole ABC, mais les données du dépositaire affichent toujours 60 actions."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "La valeur comptable entre le dépositaire et la plateforme ne correspond pas.",
        "exampleTrigger": "Les données du dépositaire indiquent une valeur comptable de 1 000 $ et la valeur comptable de la plateforme est de 1 050 $ pour un actif particulier."
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "La plateforme n'a pas généré d'instantané quotidien pour un sous-compte à la date prévue. Ceci est un indicateur que les données du dépositaire ne sont pas arrivées ou n'ont pas été traitées à temps — cela vérifie la sortie d'instantané de la plateforme elle-même, et non le fichier du dépositaire.",
        "exampleTrigger": "Un sous-compte n'a pas d'instantané quotidien pour la date prévue, même si un est attendu — souvent parce que les données du dépositaire ne sont pas arrivées ou n'ont pas été traitées à temps."
      },
      "SNAPSHOT_MISSING": {
        "description": "Un sous-compte avait un instantané quotidien la veille, mais aucun instantané n'a été enregistré pour celui-ci aujourd'hui.",
        "exampleTrigger": "Un sous-compte avait des données d'instantané quotidien hier, mais aucune n'a été enregistrée pour celui-ci aujourd'hui."
      },
      "SNAPSHOT_ANOMALY": {
        "description": "Les chiffres de contribution d'un instantané quotidien ne concordent pas : sur le premier instantané d'un compte, la valeur marchande, la contribution nette et la nouvelle contribution ne correspondent pas entre elles; sur les instantanés ultérieurs, la nouvelle contribution enregistrée ne correspond pas au changement réel de la contribution nette d'un jour à l'autre.",
        "exampleTrigger": "La contribution nette d'hier était de 1 000 $ et celle d'aujourd'hui est de 1 100 $ (un changement de 100 $), mais la nouvelle contribution enregistrée pour la journée n'est que de 50 $."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "Un instantané a besoin d'un prix du marché pour évaluer une position, mais aucun prix n'a pu être trouvé pour cette date.",
        "exampleTrigger": "Un instantané inclut une position dans le symbole XYZ, mais aucun prix du marché n'est disponible pour l'évaluer à cette date."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "Un retrait total ne peut pas être traité car les fonds disponibles sur l'ensemble du compte, après avoir additionné les soldes disponibles négatifs, sont insuffisants.",
        "exampleTrigger": "Une tentative de retrait total est effectuée sur un compte pour 5 000 $, mais le compte (y compris ses sous-comptes) ne dispose que de 4 500 $ de fonds disponibles."
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "Pour une transaction de vente totale de fonds commun de placement, la quantité attendue par la plateforme et la quantité signalée par le dépositaire diffèrent d'au moins 10 %.",
        "exampleTrigger": "La vente totale attend une quantité de 100, mais la quantité d'activité est de 85 (écart de 15 %)."
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "Pour une transaction de FNB en USD, la valeur attendue par la plateforme et la valeur signalée par le dépositaire (quantité × prix) diffèrent d'au moins 10 %.",
        "exampleTrigger": "Transaction allouée de 10 000 $, mais la valeur de remplissage est de 8 500 $ (écart de valeur de 15 %)."
      }
    }
  },
  "flagsMovedModal": {
    "title": "Les indicateurs ont été déplacés",
    "body": "Les indicateurs se trouvent maintenant dans leur propre tableau de bord avec de nouveaux filtres, des résumés et une vue détaillée. Vous y serez redirigé maintenant.",
    "confirm": "Aller aux indicateurs"
  },
  "activitiesMovedModal": {
    "title": "Les activités ont été déplacées",
    "body": "Les activités se trouvent maintenant dans leur propre tableau de bord avec des métriques et une liste de travail repensée. Vous y serez redirigé(e) maintenant.",
    "confirm": "Aller aux activités"
  },
  "activitiesV3": {
    "pageTitle": "Activités",
    "pageSubtitle": "Surveillez les métriques de rapprochement des activités du dépositaire et le carnet de commandes.",
    "tablePlaceholder": "La liste de travail des activités sera bientôt disponible",
    "metrics": {
      "error": "Impossible de charger les métriques d'activité.",
      "occurringToday": {
        "title": "Se produisant aujourd'hui",
        "hint": "Activités se produisant aujourd'hui (UTC)"
      },
      "created": {
        "title": "Créées",
        "hint": "Carnet de commandes en attente (tous les temps)"
      },
      "reconciledToday": {
        "title": "Rapprochées aujourd'hui",
        "hint": "Rapprochées aujourd'hui (UTC)"
      },
      "agingPending": {
        "title": "Ancienneté en attente",
        "hint": "En attente depuis 3 jours et plus (UTC)"
      }
    },
    "filters": {
      "state": "État",
      "stateCreated": "Créées",
      "stateReconciledToday": "Rapprochées (aujourd'hui)",
      "aging": "Ancienneté",
      "any": "Tous",
      "agingOneDay": "1 jour et plus",
      "agingThreeDays": "3 jours et plus",
      "agingSevenDays": "7 jours et plus",
      "search": "Rechercher",
      "searchPlaceholder": "Client, numéro de compte ou symbole",
      "clearFilters": "Effacer les filtres",
      "expandAll": "Tout développer",
      "collapseAll": "Tout réduire",
      "type": "Catégorie"
    },
    "table": {
      "organization": "Organisation",
      "custodianAcct": "Compte dépositaire",
      "amount": "Montant",
      "acctType": "Type de compte",
      "ticker": "Symbole",
      "state": "État",
      "aging": "Ancienneté",
      "reconciledVia": "Rapproché via",
      "empty": "Aucune activité ne correspond aux filtres actuels.",
      "client": "Nom du client",
      "date": "Date de l'activité",
      "type": "Catégorie"
    },
    "bulk": {
      "selectedCount": "{{count}} sélectionné(e)s",
      "selectAllOnPage": "Sélectionner tout sur la page",
      "clearSelection": "Effacer la sélection",
      "retry": "Nouvel essai en masse"
    },
    "detail": {
      "tabs": {
        "details": "Détails",
        "account": "Compte",
        "flags": "Indicateurs",
        "raw": "JSON brut",
        "notes": "Remarques"
      },
      "sections": {
        "general": "Général",
        "securityTrade": "Valeur mobilière et transaction",
        "transaction": "Opération"
      },
      "fields": {
        "processDate": "Date de traitement",
        "effectiveDate": "Date d'entrée en vigueur",
        "settleDate": "Date de règlement",
        "accountType": "Type de compte",
        "custodianAccountNumber": "Numéro de compte du bénéficiaire",
        "isCancel": "Annuler",
        "transactionDesc": "Description",
        "transactionId": "ID de transaction",
        "subTransactionId": "ID de sous-transaction",
        "symbol": "Symbole",
        "securityType": "Type de valeur mobilière",
        "quantity": "Quantité",
        "priceCents": "Prix",
        "accruedInterest": "Intérêt accru",
        "bookValueAmountCents": "Valeur comptable",
        "commission": "Frais",
        "cusip": "Code CUSIP"
      },
      "yes": "Oui",
      "no": "Non",
      "amountSummary": "Montant",
      "placeholders": {
        "account": "L'instantané du compte sera chargé ici dans une version ultérieure.",
        "flags": "Les indicateurs liés seront chargés ici dans une version ultérieure.",
        "notes": "L'historique des notes et la sauvegarde arriveront dans une version ultérieure. Votre brouillon est conservé si vous réduisez cette ligne."
      },
      "notes": {
        "draftPlaceholder": "Ajouter un brouillon de note…",
        "composePlaceholder": "Ajoutez des notes concernant votre enquête…",
        "save": "Enregistrer",
        "saved": "Notes enregistrées",
        "saveError": "Impossible d'enregistrer les notes",
        "historyEmptyTitle": "Aucune note pour l'instant",
        "historyEmptyReadOnlyTitle": "Aucune note pour cette activité",
        "historyEmptyDescription": "Ajoutez une note pour saisir le contexte important concernant cette activité.",
        "cleared": "Effacé"
      },
      "raw": {
        "copy": "Copier le JSON"
      },
      "footer": {
        "retry": "Réessayer",
        "retryFailed": "Échec de la nouvelle tentative. Veuillez réessayer.",
        "dismiss": "Ignorer",
        "moreActions": "Plus d'actions",
        "readOnly": "Cette activité est déjà rapprochée ({{method}})."
      },
      "dismissModal": {
        "title": "Ignorer l'activité?",
        "body": "Ignorer marque cette activité comme rapprochée sans lier de transaction interne. Cette action ne peut pas être annulée à partir de cet écran.",
        "confirm": "Ignorer",
        "cancel": "Annuler"
      },
      "flags": {
        "empty": "Aucun indicateur lié à cette activité.",
        "error": "Impossible de charger les indicateurs pour cette activité.",
        "summary": "{{total}} indicateurs · {{active}} actifs",
        "capped": "affichage de {{cap}} sur {{total}}",
        "incomplete": "Certains indicateurs d'activité n'ont pas pu être chargés.",
        "openInFlagRecon": "Ouvrir les indicateurs",
        "columns": {
          "category": "Catégorie",
          "priority": "Priorité",
          "state": "État",
          "firstSeen": "Première apparition",
          "type": "Type d'indicateur",
          "notes": "Remarques"
        }
      },
      "account": {
        "empty": "Aucun instantané de rapprochement disponible pour ce compte.",
        "dayEmpty": "Aucun instantané de rapprochement pour cette date.",
        "error": "Impossible de charger l'instantané du compte.",
        "openInRecon": "Ouvrir dans le rapprochement de compte →",
        "banner": {
          "tiesOut": "Le compte est équilibré",
          "doesNotTieOut": "Le compte n'est pas équilibré",
          "awaitingCustodian": "Pas encore comparable — en attente des données du dépositaire",
          "awaitingSystem": "Pas encore comparable — en attente des données du système",
          "awaitingBoth": "Pas encore comparable — en attente des données du système et du dépositaire",
          "asOf": "En date du {{date}}"
        },
        "asOf": {
          "title": "Instantané — en date du",
          "prev": "Jour d'instantané précédent",
          "next": "Jour d'instantané suivant",
          "diverged": "Affichage d'un instantané passé ·",
          "reset": "Réinitialiser à la dernière"
        },
        "diff": {
          "security": "Valeur mobilière",
          "systemQty": "Qté système",
          "custodianQty": "Qté dépositaire",
          "deltaQty": "Δ qté",
          "systemValue": "Valeur système",
          "custodianValue": "Valeur dépositaire",
          "deltaValue": "Δ valeur",
          "pending": "en attente",
          "cash": "Compte de trésorerie",
          "empty": "Aucune détention sur l'instantané sélectionné."
        },
        "narrative": {
          "tiesOut": "Le compte est équilibré sur le dernier instantané — cette {{type}} est déjà reflétée.",
          "securityGap": "Le rapprochement de cette {{type}} pourrait combler une partie de l'écart de quantité de {{ticker}}.",
          "cashPending": "L'écart de trésorerie pour cette {{type}} inclut les montants en transit en attente de notre côté.",
          "cashGap": "Le rapprochement de cette {{type}} devrait éliminer l'écart de trésorerie sur le dernier instantané.",
          "genericBreak": "Cette {{type}} peut être liée à la rupture de compte sur le dernier instantané."
        }
      }
    }
  }
}
